
import React from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardIcon } from "@heroicons/react/24/outline"; 
import { FiChevronRight } from "react-icons/fi";
import agentImg from "../../assets/Agent1.png"
import agent4Img from "../../assets/Agent6.png"

const CodeBlock = ({ code }) => {
  const [copied, setCopied] = React.useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="relative bg-black/90 rounded-lg overflow-hidden mb-4">
      <div className="absolute top-2 right-2 z-10">
        <button
          onClick={copyToClipboard}
          className="p-1.5 rounded text-white"
          title="Copy to clipboard"
        >
          {copied ? (
            <span className="text-green-400 text-lg leading-none">✔</span>
          ) : (
            <ClipboardIcon className="w-4 h-4" />
          )}
        </button>
      </div>

      <pre className="text-xs text-green-400 p-4 pt-8 font-mono overflow-x-auto">
        {code}
      </pre>
    </div>
  );
};

export function renderInfraLinux() {
  return <InfraLinuxComponent />;
}

function InfraLinuxComponent() {
  const navigate = useNavigate();
    return (
  <div className="transition-opacity duration-300">

    {/* Breadcrumb */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight />
      <span>Agent Setup Guide</span>
      <FiChevronRight />
      <span>Infra</span>
      <FiChevronRight />
      <span className="text-[#1b140d] dark:text-white font-medium">Linux</span>
    </nav>

    {/* Header */}
    <div className="mb-10">
      <h1 className="text-4xl font-extrabold">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
        Netraa Infra Agent Installation (Linux)
        </span>
      </h1>
      <p className="text-text-muted">
        Follow these steps to install the Netraa Infrastructure agent on Linux systems.
      </p>
    </div>

     <section className="mb-6 scroll-mt-24" id="one-agent">
        <h2 className="text-2xl font-bold text-text-main dark:text-white flex items-center gap-3">
          <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-orange-100 dark:bg-orange-900/30 text-primary border border-orange-200 dark:border-orange-900/50">
            <span className="material-symbols-outlined text-[24px]">terminal</span>
          </span>
          Netraa infra Setup Guide
        </h2>
        <div className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 shadow-subtle mb-6">
          <h2 className="text-lg font-bold text-text-main dark:text-white mb-4 scroll-mt-24" id="steps to follow">Steps to Follow:-</h2>
          <ol className="space-y-6 list-decimal list-inside marker:text-primary marker:font-bold text-text-muted dark:text-gray-400 text-sm">

            <li>
              <p className="inline font-medium text-text-main dark:text-gray-200">Sudo Login</p>
              <p className="mt-1 ml-5">Ensure you are logged in as a user with sudo privileges.</p>
            </li>

            <li>
              <p className="inline font-medium text-text-main dark:text-gray-200">Download the Infra agent file from the provided link</p>
            </li>

            <li>
              <p className="inline font-medium text-text-main dark:text-gray-200">Unzip the File:</p>
              <div className="mt-2 ml-5">
                <CodeBlock code={`unzip ONE_AGENT.zip`} />
              </div>
            </li>

            <li>
              <p className="inline font-medium text-text-main dark:text-gray-200">Change the AOP address in one-agent.sh file</p>
              <div className="w-full aspect-[14/9] flex flex-col mt-3 items-center justify-center gap-4">
                <img 
                  src={agentImg}
                  alt="High-Level Platform Diagram"
                  className="w-full h-full object-contain"
                />       
              </div>
              <p className="mt-3 ml-5">- Save the file.</p>
            </li>

            <li>
              <p className="inline font-medium text-text-main dark:text-gray-200">Run Script</p>
              <div className="mt-2 ml-5">
                <CodeBlock code={`chmod +x one-agent.sh\n./one-agent.sh`} />
              </div>
            </li>

            <li>
              <p className="inline font-medium text-text-main dark:text-gray-200">
                In Netraa, navigate to:
              </p>
              <div className="mt-2 ml-5">
                <code className="font-mono bg-white dark:bg-black/30 px-2 py-1 rounded text-xs">
                  Configuration &gt; Admin-Config &gt; Application &amp; IP Mapping
                </code>
                <p className="mt-3">
                  - Give the application/host name & select the Application type as APM Infra.<br/>
                  - Give the ip value and ip type.<br/>
                  - Select the environment and click on create application.
                </p>
              </div>
              <div className="w-full mt-3">
                <img 
                  src={agent4Img}
                  alt="Application and IP Mapping"
                  className="w-full object-contain"
                />
              </div>
            </li>

          </ol>
        </div>
      </section>
      {/* Visualize Data CTA */}
                          <section className="mb-10 flex justify-center">
                            <button
                              onClick={() => navigate("/infrahost")}
                              className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-bold text-white
                                         bg-gradient-to-r from-orange-500 to-red-600
                                         hover:from-orange-600 hover:to-red-700
                                         shadow-md hover:shadow-lg transition-all duration-300
                                         dark:shadow-orange-900/30"
                            >
                              Visualize Data
                              <FiChevronRight className="w-4 h-4" />
                            </button>
                          </section>

  </div>
);
    }